import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ImportFiles } from '../models';
import { environment } from 'src/environments/environment';
import { BaseApiService } from './baseApiService';
import { StorageKey } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class ImportFileService extends BaseApiService<ImportFiles> {
  get cacheKey(): StorageKey {
    return StorageKey.importFileServiceCache;
  }

  getUrl(operation: string, params, id: string = null): string {
    let url = `${environment.apiUrl}/importFile`;
    if (id != null) {
      url = url + '/' + encodeURIComponent(id);
    }
    return url;
  }

  protected parse(obj) {
    return ImportFiles.parse(obj);
  }

  protected unparse(obj) {
    return ImportFiles.unparse(obj);
  }
}
